module.exports = {"330381001":"安阳街道","330381002":"玉海街道","330381003":"锦湖街道","330381004":"东山街道","330381005":"上望街道","330381007":"莘塍街道","330381008":"汀田街道","330381009":"飞云街道","330381010":"仙降街道","330381011":"南滨街道","330381012":"潘岱街道","330381013":"云周街道","330381101":"塘下镇","330381116":"马屿镇","330381120":"陶山镇","330381122":"湖岭镇","330381125":"高楼镇","330381126":"桐浦镇","330381127":"林川镇","330381128":"曹村镇","330381129":"平阳坑镇","330381221":"芳庄乡","330381222":"北麂乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330381.json
// module id = 898
// module chunks = 0